const ru = {
    common: {
        save: 'Сохранить',
        cancel: 'Отмена',
        add: 'Добавить',
        new: 'Новый',
        edit: 'Изменить',
        delete: 'Удалить',
        search: 'Поиск...',
        actions: 'Действия',
        loading: 'Загрузка...',
        confirm: 'Подтвердить',
        close: 'Закрыть',
        back: 'Назад',
        all: 'Все',
        none: 'Нет',
        today: 'Сегодня',
        date: 'Дата',
        phone: 'Телефон',
        name: 'ФИО',
        status: 'Статус',
        address: 'Адрес',
        doctor: 'Врач',
        patient: 'Пациент',
        amount: 'Сумма',
        details: 'Подробнее',
        print: 'Печать',
        accept: 'Принять',
        reject: 'Отклонить',
        filter: 'Фильтр',
        year: 'Год',
        province: 'Область',
        district: 'Район',
        clear: 'Очистить',
        yes: 'Да',
        no: 'Нет',
        id: 'ID',
        code: 'Код',
        card: 'Карта',
        profile: 'Профиль',
        logout: 'Выйти',
        settings: 'Настройки',
        language: 'Язык',
        login: 'Логин',
        password: 'Пароль',
        rememberMe: 'Запомнить меня',
        signIn: 'Войти',
        saved: 'Сохранено',
        total: 'Всего',
        count: 'Кол-во',
        remark: 'Комментарий',
        type: 'Тип',
        price: 'Цена',
        empty: 'Нет данных',
        more: 'Ещё',
        select: 'Выбрать',
        required: 'Обязательное поле',
        success: 'Успешно',
        error: 'Ошибка',
        openMenu: 'Открыть меню',
        collapseSidebar: 'Свернуть панель',
        expandSidebar: 'Развернуть панель',
        dentalClinic: 'Управление стоматологией',
        perPage: '{{from}}–{{to}} / {{total}}',
        dash: '—',
        service: 'Услуга',
        searchName: 'Введите ФИО',
        createdAt: 'Дата создания',
        currency: 'сум',
        uzs: 'UZS',
        show: 'Показать',
        exportExcel: 'Экспорт в Excel',
        searchBy: 'Поиск по {{field}}',
        reset: 'Сброс',
        noExport: 'Нет данных для экспорта',
        loadError: 'Не удалось загрузить данные',
        pageOf: 'Страница {{current}}/{{total}}',
        prev: 'Предыдущая',
        next: 'Следующая',
        category: 'Категория',
        qty: 'Количество',
        view: 'Смотреть',
        sender: 'Отправитель',
        receiver: 'Получатель',
        noComment: 'Нет комментария',
        unknown: 'Неизвестно',
        update: 'Обновить',
        submit: 'Отправить',
        create: 'Создать',
        identifier: 'Идентификатор',
        visitDay: 'День приёма',
        pieces: '{{count}} шт.',
        clinicName: 'Медицинская клиника',
        email: 'Email',
        active: 'Активен',
        workPlace: 'Место работы',
        notEntered: 'Не указано',
    },
    nav: {
        main: 'Основное',
        home: 'Главная',
        patients: 'Пациенты',
        callCenter: 'Колл-центр',
        sms: 'СМС-информирование',
        catalog: 'Справочник',
        doctors: 'Врачи',
        discounts: 'Скидки',
        smsTemplates: 'СМС-шаблоны',
        services: 'Услуги',
        epidem: 'Эпидемиологический анамнез',
        mkb10: 'МКБ-10',
        partners: 'Партнёры',
        finance: 'Финансы',
        cash: 'Касса',
        debtors: 'Список должников',
        payments: 'История платежей',
        appointments: 'Приёмы',
        allAppointments: 'Все приёмы',
        queue: 'В очереди',
        reappointments: 'Повторные очереди',
        followups: 'Повторные приёмы',
        recall: 'Повторные звонки',
        patientActivity: 'Активность клиентов',
        additionalServices: 'Доп. услуги',
        analytics: 'Аналитика',
        reports: 'Отчёты',
        reportsPatients: 'По пациентам',
        reportsDoctors: 'По врачам',
        reportsFinance: 'По финансам',
        reportsPartners: 'По партнёрам',
        inventory: 'Склад',
        storeProducts: 'Товары склада',
        categories: 'Категории',
        warehouse: 'Склад',
        requests: 'Заявки',
        resendRequests: 'Возвращённые заявки',
        doctorVisits: 'Приёмы врача',
        doctorRequest: 'Заявка',
        technicianLab: 'Лаборатория',
        technicianObjects: 'Объекты техника',
        technicianRequests: 'Заказы технику',
        settings: 'Настройки',
        roles: 'Роли',
        users: 'Пользователи',
    },
    status: {
        queue: 'В очереди',
        examined: 'На приёме',
        new: 'Новый приём',
        pending: 'Ожидает оплату',
        payed: 'Оплачен',
        revisit: 'В очереди',
        closed: 'Закрыт',
        inactive: 'Неактивен',
        planned: 'Запланирован',
        completed: 'Выполнен',
        canceled: 'Отменён',
        process: 'В процессе',
        accept: 'Принято',
        cancel: 'Отклонено',
        inBase: 'Есть',
        notInBase: 'Нет',
        primary: 'Основная',
        extra: 'Дополнительная',
        all: 'Все',
        ambulatory: 'Амбулаторная',
        stationary: 'Стационарная',
    },
    login: {
        loading: 'Загрузка...',
        success: 'Вы успешно вошли в систему',
        error: 'Неверные данные для входа',
        logoAlt: 'Логотип',
        videoFallback: 'Ваш браузер не поддерживает видео',
        welcome: 'Добро пожаловать',
        subtitle: 'Войдите, чтобы продолжить работу',
        panelText: 'Календарь, пациенты и приёмы — в одном месте',
        signingIn: 'Входим...',
    },
    settings: {
        title: 'Настройки',
        subtitle: 'Язык интерфейса и параметры платформы',
        languageTitle: 'Язык интерфейса',
        languageHint: 'Выбранный язык сохраняется на этом устройстве и применяется сразу ко всей платформе.',
        applied: 'Язык изменён',
        ru: 'Русский',
        uzLatn: 'Узбекский (латиница)',
        uzCyrl: 'Узбекский (кириллица)',
        current: 'Текущий язык',
    },
    patients: {
        title: 'Пациенты',
        new: 'Новый',
        search: 'Поиск...',
        birthDate: 'Дата рождения',
        card: 'Карта',
        edit: 'Редактировать',
        created: 'Пациент создан',
        updated: 'Пациент обновлён',
        saveError: 'Ошибка при сохранении',
        colId: '№',
        colName: 'ФИО',
        colBirth: 'Дата рождения',
        colStatus: 'Статус',
        colAddress: 'Адрес',
        colPhone: 'Телефон',
        colActions: 'Действия',
        formCreate: 'Новый пациент',
        formEdit: 'Изменить ⟶ {{name}}',
        formName: 'ФИО пациента',
        formNameReq: 'Укажите ФИО пациента',
        formAddress: 'Место жительства',
        formAddressReq: 'Укажите место жительства',
        formPartner: 'Партнёр',
        formPartnerReq: 'Выберите партнёра',
        formPhone: 'Телефон',
        formPhoneReq: 'Укажите телефон',
        formPhoneHint: 'Введите номер с кодом страны',
        formProfession: 'Профессия',
        formBirth: 'Дата рождения',
        formBirthReq: 'Выберите дату рождения',
        formHome: 'Домашний адрес',
        formHomeReq: 'Укажите домашний адрес',
        formWork: 'Адрес работы',
        formRemark: 'Комментарий',
        formGender: 'Пол',
        formGenderReq: 'Выберите пол',
        formPhoto: 'Фото',
        formUpload: 'Загрузить файл',
        formUploadHint: 'Перетащите файл сюда или нажмите, чтобы выбрать',
        formSubmit: 'Сохранить пациента',
        formSubmitAdd: 'Добавить пациента',
    },
    doctors: {
        title: 'Врачи',
        add: 'Добавить',
        edit: 'Изменить врача',
        create: 'Новый врач',
        delete: 'Удалить',
        colPhone: 'Телефон',
        colRole: 'Роль',
        fio: 'ФИО',
        login: 'Логин',
        password: 'Пароль',
        passwordRepeat: 'Повторите пароль',
        phone: 'Телефон',
        created: 'Врач создан',
        updated: 'Врач обновлён',
        deleted: 'Врач удалён',
        nameRequired: 'Заполните ФИО',
        loginRequired: 'Заполните логин',
        passwordRequired: 'Заполните пароль',
        passwordMismatch: 'Пароли должны совпадать',
        confirmPasswordRequired: 'Повторите пароль',
        phoneRequired: 'Заполните телефон',
        phoneTaken: 'Этот телефон уже зарегистрирован',
    },
    services: {
        title: 'Основные услуги',
        add: 'Добавить',
        edit: 'Редактировать услугу',
        create: 'Добавить услугу',
        name: 'Название услуги',
        price: 'Цена',
        kind: 'Вид',
        serviceType: 'Тип услуги',
        search: 'Поиск услуги',
        cancel: 'Отмена',
        save: 'Сохранить',
    },
    partners: {
        title: 'Все партнёры',
        add: 'Добавить',
        create: 'Добавить партнёра',
        edit: 'Изменить партнёра',
        delete: 'Удалить партнёра',
        phone: 'Телефон',
        created: 'Партнёр добавлен',
        updated: 'Партнёр обновлён',
        deleted: 'Партнёр удалён',
        saveError: 'Не удалось сохранить партнёра',
        deleteError: 'Не удалось удалить партнёра',
    },
    discounts: {
        title: 'Доступные скидки',
        create: 'Добавить скидку',
        name: 'Название скидки',
        percent: 'Скидка (%)',
        startDate: 'Дата начала',
        endDate: 'Дата окончания',
        submit: 'Создать',
        namePlaceholder: 'Введите название акции',
        created: 'Скидка создана',
        createError: 'Не удалось создать скидку',
    },
    sms: {
        title: 'СМС-рассылка',
        templates: 'Шаблоны сообщений',
        addTemplate: 'Добавить шаблон',
        editTemplate: 'Редактировать шаблон',
        send: 'Отправить SMS',
        searchPatient: 'Поиск пациента...',
        birthdayToday: 'День рождения сегодня',
        showAll: 'Показать всех',
        selectWarning: 'Выберите пациентов и шаблон',
        sent: 'SMS отправлено',
        sendError: 'Не удалось отправить SMS',
        loadPatientsError: 'Не удалось загрузить пациентов',
        loadTemplatesError: 'Не удалось загрузить шаблоны',
    },
    smsTemplates: {
        title: 'Шаблоны сообщений',
        legalEntity: 'Юр. лицо',
        inn: 'ИНН',
        senderName: 'Имя отправителя',
        templateType: 'Тип шаблона',
        text: 'Текст',
        service: 'Сервис',
        transaction: 'Транзакция',
        loadError: 'Не удалось загрузить шаблоны',
        created: 'Шаблон создан',
        updated: 'Шаблон обновлён',
        deleted: 'Шаблон удалён',
        saveError: 'Не удалось сохранить шаблон',
        deleteError: 'Не удалось удалить шаблон',
    },
    epidem: {
        title: 'Эпидемиологический анамнез',
        edit: 'Изменить запись',
        create: 'Добавить запись',
        name: 'Название',
    },
    mkb10: {
        title: 'МКБ-10',
        additionalInfo: 'Дополнительная информация',
    },
    payments: {
        title: 'История платежей',
        date: 'Дата оплаты',
        serviceNumber: 'Номер услуги',
        total: 'Общая сумма',
        paid: 'Оплачено',
        left: 'Остаток',
        search: 'Поиск...',
        searchBtn: 'Найти',
        serviceName: 'Название услуги',
        serviceCount: 'Количество услуг',
        txAmount: 'Сумма транзакции',
        txType: 'Тип транзакции',
        txDate: 'Дата транзакции',
        cash: 'Наличные',
        card: 'Карта',
        bank: 'Банковский перевод',
        online: 'Онлайн оплата',
        credit: 'В кредит',
        creditCard: 'Кредитная карта',
        enterAmount: 'Введите сумму оплаты',
        pay: 'Оплатить',
        paymentMethod: 'Способ оплаты',
        paymentStatus: 'Статус оплаты',
        remaining: 'Остаток суммы',
        selectedOrder: 'Выбранный заказ',
        noOrders: 'Нет доступных заказов для оплаты',
        payError: 'Ошибка при выполнении оплаты',
        paySuccess: 'Оплата выполнена: {{id}}',
        paidLabel: 'Оплачено: {{id}}',
        receiptNo: 'Чек №',
        thankYou: 'Спасибо за покупку!',
        stayHealthy: 'Будьте здоровы! Спасибо за визит в нашу клинику.',
        noDiscount: 'Нет скидки',
        discount: 'Скидка (%)',
        debit: 'Дебет',
        totalPaid: 'Всего оплачено',
        finish: 'Завершить',
        invoice: 'Счёт-фактура',
        enterPayment: 'Ввод оплаты',
        receipt: 'Чек',
        visitNumber: 'Номер визита: {{id}}',
        payTitle: 'Оплата — {{id}}',
        paymentSlip: 'Квитанция об оплате',
        mainService: 'Основная услуга',
        noServiceData: 'Нет данных об услугах',
        noOrderData: 'Нет данных о заказе',
        paymentAmount: 'Сумма оплаты',
    },
    debtors: {
        title: 'Список должников',
        pay: 'Оплатить',
        orderId: 'ID заказа',
        transaction: 'Транзакция',
        debt: 'Долг',
    },
    admissions: {
        queue: 'Очередь',
        reappointments: 'Повторные очереди',
        followups: 'Повторные приёмы',
        recall: 'Повторные звонки',
        dispensary: 'Диспансерный учёт',
        paymentReceipt: 'Оплата → чек',
        paymentInfo: 'Данные оплаты',
        printReceipt: 'Печать чека',
        callResult: 'Результат звонка',
        addToQueue: 'Добавить в очередь',
        revisitDate: 'Дата повторного приёма',
        visitCreated: 'Визит создан для пациента {{name}}',
        visitCreateError: 'Ошибка при создании визита',
        visitId: 'ID визита',
        noServices: 'Нет услуг',
        payment: 'Оплата',
        remaining: 'Остаток',
    },
    reports: {
        patients: 'Отчёт по пациентам',
        doctors: 'Отчёт по врачам',
        finance: 'Отчёт по финансам',
        financeDate: 'Отчёт врача по финансам {{date}}',
        partners: 'Аналитика по партнёрам',
        partnersShare: 'Доля партнёров',
        doctorDetail: 'Подробный отчёт врача',
        info: 'Данные',
        show: 'Показать',
        exportExcel: 'Экспорт в Excel',
        doctorName: 'ФИО врача',
        patientsSeen: 'Пациентов принято',
        patientsCount: 'Количество пациентов',
        totalAmount: 'Общая сумма',
        partner: 'Партнёр',
        todayCame: 'Пришло сегодня',
        newPatients: 'Новых пациентов',
        repeatPatients: 'Повторных пациентов',
        share: 'Доля (%)',
        allPartners: 'Все партнёры',
        patientName: 'Имя пациента',
        noExport: 'Нет данных для экспорта',
        loadError: 'Не удалось загрузить данные',
        badFormat: 'Неверный формат данных от API',
        search: 'Поиск',
        reset: 'Сброс',
        searchBy: 'Поиск по {{field}}',
    },
    store: {
        categories: 'Все категории',
        addCategory: 'Добавить категорию',
        editCategory: 'Изменить категорию',
        warehouse: 'Склад',
        history: 'История',
        add: 'Добавить',
        edit: 'Изменить',
        requests: 'Заявки',
        resend: 'Возвращённые заявки',
        accept: 'Принять',
        reject: 'Отклонить',
        details: 'Подробности',
        fullRemark: 'Полный комментарий',
        doctorRequests: 'Заявки',
        returnGoods: 'Возврат товара',
        newRequest: 'Создать заявку',
        name: 'Название',
        addNew: 'Добавить',
        namePh: 'название',
        update: 'Обновить',
        deleted: 'Категория удалена',
        deleteError: 'Ошибка удаления',
        added: 'Категория добавлена',
        updated: 'Категория обновлена',
        saveError: 'Ошибка сохранения',
        grandTotal: 'Итого',
        requestHistory: 'История заявок',
        sender: 'Отправитель',
        receiver: 'Получатель',
        notReceived: 'Не принято',
        noRemark: 'Нет комментария',
        historyQty: 'История (Кол-во: {{qty}})',
        nameFilter: 'введите название...',
        pickCategory: 'Выберите категорию',
        excelExport: 'Экспорт в Excel',
        exportOk: 'Экспорт выполнен',
        exportError: 'Ошибка экспорта',
        fillFields: 'Заполните все поля',
        loadError: 'Не удалось загрузить данные',
        productUpdated: 'Товар успешно изменён',
        view: 'Смотреть',
        pricePh: 'цена',
        qtyPh: 'количество',
        categoryPh: 'категория',
        confirmer: 'Подтверждающий',
        notConfirmed: 'Не подтверждено',
        remarks: 'Комментарии',
        commentMin: 'Комментарий должен содержать не менее 10 символов!',
        commentForAccept: 'Комментарий для принятия',
        commentForReject: 'Комментарий для отклонения',
        commentPh: 'Введите комментарий...',
        phoneNumber: 'Номер',
        returnedOk: 'Товар успешно возвращён на склад!',
        confirmAccept: 'Вы действительно хотите принять?',
        confirmReject: 'Вы действительно хотите отклонить?',
        addedOk: 'Заявка добавлена',
        addError: 'Ошибка добавления',
        updateError: 'Ошибка обновления',
        deletedOk: 'Удалено',
        fetchError: 'Ошибка загрузки заявок',
        qtyMax: 'Количество не должно превышать 100!',
        returnOk: 'Товар успешно возвращён',
        returnError: 'Ошибка при возврате товара',
        fetchWarehousesError: 'Ошибка загрузки склада',
        createOk: 'Заявка успешно отправлена!',
        createError: 'Ошибка создания заявки',
        send: 'Отправить',
        qtyLabel: 'Количество (макс: {{qty}})',
        qtyRequired: 'Введите количество',
        qtyExceed: 'Доступно только: {{qty}} шт.',
        qtyPhInput: 'Введите количество',
        commentOptional: 'Введите комментарий (необязательно)',
        pickProduct: 'Выберите товар',
        pickProductRequired: 'Пожалуйста, выберите товар!',
        qtyZero: 'Количество не может быть 0!',
        qtyMaxAvailable: 'Максимум доступно: {{qty}} шт.',
        warehouseLabel: 'Склад',
        fetchDataError: 'Ошибка загрузки данных',
        fetchCategoriesError: 'Ошибка загрузки категорий',
        requestDeleted: 'Заявка удалена',
        requestDeleteError: 'Ошибка удаления заявки',
        comment: 'Комментарий',
    },
    callCenter: {
        title: 'Колл-центр',
        new: 'Новые',
        planned: 'Запланированные',
        completed: 'Выполненные',
        canceled: 'Отменённые',
        allTime: 'За всё время',
        searchName: 'ФИО',
        searchPhone: 'Телефон',
        date: 'Дата',
        schedule: 'Запланировать',
        scheduleCall: 'Запланировать звонок',
        newUser: 'Новый пользователь',
        all: 'Все',
        source: 'Откуда узнали?',
        base: 'База',
        callTime: 'Время звонка',
        inBase: 'В базе',
        add: 'Добавить',
        pickDateTime: 'Выберите дату и время',
        fillNamePhone: 'Заполните имя и телефон',
        added: 'Пользователь добавлен',
        addError: 'Не удалось добавить',
        loadError: 'Не удалось загрузить данные',
        statsError: 'Не удалось загрузить статистику',
        partnersError: 'Не удалось загрузить партнёров',
        patientsError: 'Не удалось загрузить пациентов',
        statusUpdated: 'Статус обновлён',
        statusError: 'Не удалось обновить статус',
        notFound: 'Запись не найдена',
        time: 'Время',
        sourcePlaceholder: 'Выберите источник',
        userName: 'Имя пользователя',
        baseStatus: 'Статус базы',
        birthAt: 'Дата рождения',
        age: 'Возраст',
        minor: 'Несовершеннолетний',
        adult: 'Совершеннолетний',
        guardians: 'Родственники',
        guardian: 'Опекун',
        relative: 'Родственник',
        addGuardian: 'Добавить',
        noGuardians: 'Нет прикреплённых лиц',
        guardianName: 'ФИО',
        guardianPhone: 'Телефон, например 998901112233',
        relationship: 'Кем приходится',
        address: 'Адрес',
        notes: 'Заметка',
        guardianNameRequired: 'Укажите ФИО',
        guardianPhoneRequired: 'Укажите телефон',
        relationshipRequired: 'Укажите родство',
        guardianAdded: 'Человек добавлен',
        guardianUpdated: 'Данные обновлены',
        guardianDeleted: 'Запись удалена',
        guardianSaveError: 'Не удалось сохранить',
        guardianDeleteConfirm: 'Удалить этого человека из лида?',
        forbidden: 'Недостаточно прав',
    },
    doctorVisits: {
        title: 'Приёмы врача',
        endVisit: 'Завершить приём',
        confirm: 'Подтверждение',
        confirmEnd: 'Вы уверены, что хотите завершить приём?',
        ended: 'Приём успешно закрыт',
        yesEnd: 'Да, завершить',
        patientCard: 'Карта пациента',
        patientName: 'Пациент',
        unknownDoctor: 'Неизвестный врач',
        unknownPatient: 'Неизвестный пациент',
        service: 'Услуга',
        time: 'Время',
        queueNo: 'Очередь',
        allStatuses: 'Все',
        loadError: 'Не удалось загрузить приёмы',
        forbidden: 'Доступно только врачу',
        endError: 'Не удалось завершить приём',
    },
    calendar: {
        search: 'Поиск...',
        pickDate: 'Выберите дату',
        newVisit: 'Новый приём',
        editVisit: 'Редактировать приём',
        viewVisit: 'Просмотр приёма',
        welcome: 'Добро пожаловать',
        today: 'Сегодня',
        todayDoctors: 'Сегодня · врачи',
        calendar: 'Календарь',
        doctors: 'Врачи',
        day: 'День',
        week: 'Неделя',
        month: 'Месяц',
        visits: 'приёмов',
        withDoctor: 'с врачом',
        withoutDoctor: 'без врача',
        noRecords: 'Записей нет',
        unassigned: 'Врач не назначен',
        dentist: 'Стоматолог',
        add: 'Добавить',
        past: 'Прошедший',
        planned: 'План',
        todayLabel: 'Сегодня',
        prevMonth: 'Предыдущий месяц',
        nextMonth: 'Следующий месяц',
        prevWeek: 'Предыдущая неделя',
        nextWeek: 'Следующая неделя',
        prevDay: 'Предыдущий день',
        nextDay: 'Следующий день',
        layoutMonth: '1 · Месячный календарь',
        layoutDay: '2 · Врачи (день)',
        layoutWeek: '2 · Врачи (неделя)',
        layoutMonthBoard: '2 · Врачи (месяц)',
        todayVisits: 'Сегодняшние приёмы',
        date: 'Дата',
        fio: 'ФИО',
        phone: 'Телефон',
        patientOptional: 'Пациент (необязательно)',
        doctorOptional: 'Врач (необязательно)',
        description: 'Описание',
        save: 'Сохранить',
        update: 'Изменить',
        deleteEvent: 'Удалить запись',
        searchPatient: 'Поиск по ФИО...',
        pickDoctor: 'Выберите врача',
        descriptionPh: 'Описание...',
        todayReceptions: 'Сегодняшние приёмы',
        bugungi: 'Сегодняшние приёмы',
        updated: 'Запись обновлена',
        updateError: 'Не удалось обновить запись',
        created: 'Запись создана',
        createError: 'Не удалось создать запись',
        pickDateError: 'Выберите дату',
        fioRequired: 'Укажите ФИО',
        phoneRequired: 'Укажите телефон',
        dateRequired: 'Выберите дату',
        noTodayVisits: 'Сегодня приёмов нет',
        noDoctorsList: 'Нет списка врачей',
        moreCount: '+{{count}} ещё',
        layoutCalendar: '1 · Календарь',
        layoutDoctors: '2 · Врачи',
        registerPatient: 'Регистрация пациента',
        phonePh: 'Номер телефона:',
        dowMon: 'Пн',
        dowTue: 'Вт',
        dowWed: 'Ср',
        dowThu: 'Чт',
        dowFri: 'Пт',
        dowSat: 'Сб',
        dowSun: 'Вс',
    },
    dental: {
        formula: 'Зубная формула',
        upper: 'Верхняя',
        lower: 'Нижняя',
        all: 'Все',
        clear: 'Очистить',
        unselected: 'Не выбран',
        selected: 'Выбран',
        hasRemark: 'Есть заметка',
        selectedCount: 'Выбрано',
        save: 'Сохранить',
        jawUpper: 'верхняя челюсть',
        jawLower: 'нижняя челюсть',
        tooth: 'Зуб {{id}}',
        remarkPh: 'Введите комментарий',
        remarksTitle: 'Комментарии по выбранным зубам',
        problems: 'Проблемы',
        xrays: 'Рентгены',
        noXrays: 'Нет рентгеновских снимков',
        jawAreas: 'Области челюсти',
        pickJaw: 'Выберите область челюсти',
        pickProblem: 'Выберите проблему',
        searchProblems: 'Поиск по челюсти и проблемам',
        jawLeft: 'Левая сторона',
        jawRight: 'Правая сторона',
        malocclusion: 'Неправильный прикус',
        crossbite: 'Перекрещенный прикус',
        diastema: 'Диастема',
        crowding: 'Кривизна зубов',
        malposition: 'Неправильное положение зубов',
        teethSaved: 'Данные о зубах успешно отправлены',
    },
    patientCard: {
        title: 'Карта пациента',
        hideProfile: 'Скрыть профиль',
        showProfile: 'Показать профиль',
        visitNo: 'Приём №',
        startVisit: 'Начать приём',
        starting: 'Запуск...',
        endVisit: 'Завершить приём',
        ending: 'Завершение...',
        createVisit: 'Создать приём',
        addEpidem: 'Добавить эпиданамнез',
        notAvailable: 'Нет данных',
        birthDate: 'Дата рождения',
        phone: 'Телефон',
        province: 'Область',
        district: 'Район',
        partner: 'Партнёр',
        address: 'Адрес',
        profession: 'Профессия',
        gender: 'Пол',
        visits: 'Приёмы',
        noteText: 'Текст заметки',
        male: 'Мужской',
        female: 'Женский',
        addToVisit: 'Добавить на приём',
        pickService: 'Выберите услугу',
        discount: 'Скидка',
        pickDiscount: 'Выберите скидку',
        visitAdded: 'Приём добавлен',
        noDoctors: 'Нет доступных врачей',
        newVisitSubmit: 'Добавить новый приём',
        readyTitle: 'Пациент готов к приёму',
        readyDesc: 'Пациент оплатил услугу, приём можно начать',
        addedTitle: 'Добавлен новый приём',
        addedDesc: 'Приём создан, но пациент ещё не оплатил',
        notAddedTitle: 'Пациент не добавлен на приём',
        notAddedDesc: 'Чтобы начать лечение, добавьте пациента на приём',
        tabNewVisit: 'Новый приём',
        tabHistory: 'Визиты и звонки',
        tabViewVisits: 'Просмотр приёмов',
        visitsTitle: 'Приёмы',
        visitAt: 'Визит: {{date}}',
        visitNoN: 'Визит №{{id}}',
        dateAt: 'Дата: {{date}}',
        revisitDate: 'Дата повторного приёма',
        onDispensary: 'Взят на диспансерный учёт',
        viewAll: 'Смотреть все данные',
        fileNotUploaded: 'Файл не загружен',
        noInfo: 'Нет информации',
        visitDate: 'Дата визита',
        paymentType: 'Тип оплаты',
        loadingData: 'Загрузка данных...',
        complaint: 'Жалоба',
        illness: 'Заболевание',
        diagnosis: 'Диагноз',
        illHistory: 'История болезни',
        anamnez: 'Анамнез {{n}}',
        treatment: 'Лечение',
        oralView: 'Вид полости рта.',
        teethState: 'Состояние зубов:',
        totalForms: 'Всего {{total}} форм',
        workAddress: 'Место работы',
        sentBy: 'Кто направил',
        epidemAdded: 'Эпидемиологический анамнез добавлен',
        added: 'Добавлено',
        noDistrict: 'Нет данных о районе',
        noPartner: 'Нет данных о партнёре',
        colTitle: 'Наименование',
        colDesc: 'Описание',
        colActive: 'Активен',
        cityDistrict: 'Город/район',
        filesTypes: 'Рентген, документ, фото ...',
        createVisitAction: 'Создать приём',
        patientFio: 'ФИО пациента',
        condExtracted: 'Удалённый зуб',
        condRoot: 'Остаток корня',
        condCaries: 'Кариес',
        condPulpitis: 'Пульпит',
        condPeriodontitis: 'Периодонтит',
        condParadontosis: 'Пародонтоз',
        condMobility: 'Подвижность',
        condFilling: 'Коронка',
        condArtificial: 'Искусственный зуб',
    },
    notfound: {
        code: '404',
        title: 'Страница не найдена',
        text: 'К сожалению, этой страницы не существует. Вы можете вернуться на главную.',
        home: 'На главную',
    },
    roles: {
        title: 'Роли',
        create: 'Добавить роль',
        select: 'Выберите роль',
    },
    users: {
        title: 'Пользователи',
        add: 'Добавить',
        edit: 'Редактировать',
        delete: 'Удалить',
        create: 'Новый пользователь',
        editTitle: 'Редактирование пользователя',
        role: 'Роль',
        phonePlaceholder: 'Номер телефона',
        created: 'Пользователь создан',
        updated: 'Пользователь обновлён',
        deleted: 'Пользователь удалён',
        passwordMismatch: 'Пароли не совпадают',
        addTechnician: 'Добавить техника',
        technicianCreated: 'Техник создан',
    },
    form43: {
        part1: 'I часть',
        part2: 'II часть',
        part3: 'III часть',
        part4: 'IV часть',
        headerLeft: 'МИНИСТЕРСТВО ЗДРАВООХРАНЕНИЯ РЕСПУБЛИКИ УЗБЕКИСТАН',
        headerRight: 'Медицинский документ формы 043/у Министерства здравоохранения',
        title: 'МЕДИЦИНСКАЯ КАРТА СТОМАТОЛОГИЧЕСКОГО ПАЦИЕНТА',
        fullName: 'Фамилия, имя, отчество',
        birthYear: 'Год рождения',
        address: 'Место жительства',
        job: 'Место работы, профессия',
        diagnosis: 'Диагноз',
        complaints: 'Жалобы',
        childhoodHistory: 'Какими болезнями болел в детстве и позднее',
        childhoodHistoryPh: 'История болезни',
        currentHistory: 'История начала настоящего заболевания',
        currentHistoryPh: 'История настоящего заболевания',
        epidemQ1: 'Эпиданамнез: 1) Был ли контакт с инфекционными больными?',
        epidemQ2: '2) Выезжал ли за пределы места жительства в течение 1 недели – 2 месяцев?',
        epidemQ2Ph: 'Выезжал ли за пределы места жительства?',
        epidemQ3: '3) Какие инфекционные заболевания перенёс?',
        epidemQ4: '4) Лечился ли стационарно и амбулаторно?',
        epidemQ5: '5) Получал ли парентеральные процедуры?',
        epidemQ6: '6) Пользовался ли бытовыми услугами?',
        allergy: 'Аллергоанамнез: есть ли аллергия на лекарства и продукты?',
        allergyPh: 'Аллергия есть, нет?',
        clinicalDiagnosis: 'Диагноз по анамнезу и клиническим показаниям',
        appearance: 'Внешний вид',
        teethCondition: 'Состояние зубов',
        condExtracted: 'Удалённый зуб – O',
        condRoot: 'Остаток корня – R',
        condCaries: 'Кариес – C',
        condPulpitis: 'Пульпит – P',
        condPeriodontitis: 'Периодонтит – A',
        condMobility: 'Подвижность – I-III',
        condFilling: 'Коронка – K',
        condArtificial: 'Искусственный зуб – I',
        treatment: 'Лечение',
    },
    queues: {
        title: 'Новая очередь',
        select: 'Выберите пациента и врача',
        visitTime: 'Время приёма',
        busy: 'занят',
        noDate: 'Нет даты',
        notStarted: 'Приём не начат',
        doctorsError: 'Не удалось загрузить врачей',
        created: 'Визит создан для пациента {{patientId}} и врача {{doctorId}}',
        confirmVisit: 'Подтвердить визит',
    },
    followupsPage: {
        title: 'Повторные звонки',
        dueHint: 'Пациенты с наступившим сроком: {{count}}',
        dueDate: 'Срок звонка',
        enterResult: 'Ввести результат',
        loadError: 'Список не загружен',
        saved: 'Результат сохранён',
        alreadyClosed: 'Напоминание уже закрыто',
        saveError: 'Ошибка при сохранении',
        total: 'Всего: {{total}}',
        remarkOptional: 'Комментарий (необязательно)',
        remarkPh: 'Комментарий...',
        noAnswer: 'Не ответил',
        contacted: 'Связались',
        willVisit: 'Сказал, что придёт',
    },
    unauthorized: {
        title: 'Нет доступа',
        text: 'У вас нет прав для просмотра этой страницы.',
        home: 'На главную',
    },
    admissionPrint: {
        title: 'Данные пациента',
        print: 'Распечатать',
        diseases: 'Международная классификация болезней',
        conclusion: 'Заключение врача',
        noConclusion: 'Заключения нет...',
        revisits: 'Повторные приёмы',
        noRevisits: 'Повторных визитов нет',
        dispensary: 'Диспансерные списки',
        dispensaryDate: 'Дата диспансера',
        noDispensary: 'Диспансерных записей нет',
        files: 'Загруженные файлы',
        notFound: 'Информация о пациенте не найдена',
        photo: 'Фото',
        code: 'Код',
        mkb10: 'МКБ-10',
        conclusionLabel: 'Заключение',
        loading: 'Загрузка',
        filesTypes: 'Рентген, документ, фото ...',
        loadError: 'Не удалось получить данные пациента',
    },
    visit: {
        conclusion: 'Заключение врача',
        dragFiles: 'Перетащите файл(ы) сюда или',
        clickFiles: 'нажмите, чтобы выбрать файл(ы)',
        saveSend: 'Сохранить и отправить',
        loadingTemplates: 'Загрузка шаблонов...',
        pickTemplate: 'Выберите шаблон',
        addTemplate: 'Добавить шаблон',
        templateName: 'Введите имя шаблона',
        sendTemplate: 'Отправить шаблон',
        send: 'Отправить',
        revisit: 'Повторный приём',
        addRevisit: 'Добавить повторный приём',
        procedure: 'Отправить на процедуру',
        addDispensary: 'Добавить в диспансерный список',
        filesSent: 'Изображения отправлены',
        filesError: 'Ошибка загрузки файлов',
        commentSent: 'Комментарий отправлен',
        commentError: 'Ошибка отправки комментария',
        templateSent: 'Шаблон отправлен',
        templateError: 'Ошибка отправки шаблона',
        mkbAdded: 'МКБ добавлен',
        pickDate: 'Пожалуйста, выберите день',
        revisitSet: 'Повторный приём: {{date}}',
        dispensarySet: 'Диспансерный список: {{date}}',
        colName: 'Наименование',
    },
    history: {
        loadFailed: 'История не загружена',
        summary: 'Общие сведения',
        lastVisit: 'Последний визит',
        nextVisit: 'Следующий приём',
        nextContact: 'Следующий повторный контакт',
        timeNotSet: 'Время не указано',
        visitsHistory: 'История визитов',
        noVisits: 'Визитов нет',
        callsHistory: 'История звонков (последние 10)',
        noCalls: 'Истории звонков нет',
        registeredBy: 'Зарегистрировал',
        services: 'Услуги',
        noAnswer: 'Не ответил',
        contacted: 'Связались',
        willVisit: 'Обещал прийти',
    },
    techRequest: {
        catalogTitle: 'Объекты техника',
        catalogNew: 'Новый объект',
        catalogEdit: 'Редактировать объект',
        requestsTitle: 'Заказы технику',
        requestsTitleDoctor: 'Мои заказы технику',
        requestsTitleTech: 'Заказы',
        newOrder: 'Новый заказ',
        object: 'Объект',
        parameters: 'Параметры',
        addParameter: 'Добавить параметр',
        options: 'Варианты',
        requiredParam: 'Обязательный',
        objectPrice: 'Цена объекта',
        paramPrice: 'Цена параметра',
        estimatedTotal: 'Предварительная сумма',
        finalPrice: 'Итоговая цена',
        parametersTotal: 'Сумма параметров',
        description: 'Дополнительные требования',
        descriptionPh: 'Опишите дополнительные требования',
        actionNote: 'Комментарий',
        actionNotePh: 'Комментарий к действию (необязательно)',
        technician: 'Техник',
        orderedBy: 'Заказ отправил',
        selectObject: 'Выберите объект',
        selectTechnician: 'Выберите техника',
        selectPatient: 'Выберите пациента',
        preview: 'Расчёт',
        snapshotNote: 'Цены сохранены на момент отправки заказа.',
        pending: 'Новый',
        inProgress: 'В работе',
        completed: 'Выполнен',
        returned: 'Возвращён',
        start: 'Начать работу',
        complete: 'Отметить выполненным',
        returnWork: 'Вернуть на доработку',
        returnReason: 'Причина возврата',
        lastReturn: 'Последний возврат',
        changePrice: 'Изменить цену',
        newPrice: 'Новая цена',
        priceNote: 'Комментарий к цене',
        history: 'История',
        historyEmpty: 'Истории пока нет',
        statusChanged: 'Смена статуса',
        priceChanged: 'Изменение цены',
        inactive: 'Неактивен',
        active: 'Активен',
        deactivate: 'Скрыть из выбора',
        activate: 'Активировать',
        deleteConfirm: 'Удалить объект из каталога? Старые заказы сохранятся.',
        loadError: 'Не удалось загрузить данные',
        saveError: 'Не удалось сохранить',
        forbidden: 'Недостаточно прав',
        conflict: 'Это действие сейчас недоступно',
        notFound: 'Запись не найдена',
        createdOk: 'Заказ отправлен',
        savedOk: 'Сохранено',
        deletedOk: 'Удалено',
        startedOk: 'Работа начата',
        completedOk: 'Отмечено выполненным',
        returnedOk: 'Заказ возвращён',
        priceUpdated: 'Цена обновлена',
        noTechnicians: 'Нет доступных техников',
        noObjects: 'Нет активных объектов',
        requiredParamsMissing: 'Заполните обязательные параметры',
        descriptionRequired: 'Укажите дополнительные требования',
        returnRequired: 'Укажите причину возврата',
        optionsRequired: 'Добавьте хотя бы один вариант',
        paramName: 'Название параметра',
        from: 'Было',
        to: 'Стало',
        tooth: 'Зуб',
        toothOptional: 'необязательно',
        adultTeeth: 'Постоянные',
        childTeeth: 'Молочные',
    },
    patientActivity: {
        title: 'Активность клиентов',
        search: 'Имя, телефон или код',
        overdue: 'Не были 6 месяцев',
        recent: 'Были за 6 месяцев',
        never_visited: 'Ещё не приходили',
        visited: 'Все приходившие',
        overdueHint: 'Последний визит до границы',
        recentHint: 'Последний визит после границы',
        neverHint: 'Нет закрытого приёма',
        visitedHint: 'Хотя бы один визит',
        lastVisit: 'Последний визит',
        visitsCount: 'Приёмы',
        createdAt: 'Создан',
        neverVisitedLabel: 'Ещё не приходил',
        history: 'История',
        cutoffNote: 'Сегодня {{today}} · граница 6 месяцев {{cutoff}}',
        loadError: 'Не удалось загрузить список',
        forbidden: 'Недостаточно прав',
    },
    additionalServices: {
        title: 'Дополнительные услуги',
        add: 'Добавить',
        create: 'Новая дополнительная услуга',
        edit: 'Изменить услугу',
        search: 'Поиск по названию',
        name: 'Название',
        price: 'Цена',
        description: 'Описание',
        prefix: 'Префикс',
        time: 'Минуты',
        author: 'Автор',
        createdBy: 'Создал',
        performedBy: 'Кто изменил',
        history: 'История',
        includeDeleted: 'Показать архив',
        active: 'Активна',
        archived: 'Архив',
        created: 'Услуга создана',
        updated: 'Услуга обновлена',
        deleted: 'Услуга удалена',
        deleteConfirm: 'Удалить эту услугу? История сохранится.',
        nameRequired: 'Укажите название',
        priceRequired: 'Укажите цену',
        saveError: 'Не удалось сохранить',
        forbidden: 'Только для администратора',
        notFound: 'Услуга не найдена',
        action: 'Действие',
        changes: 'Изменения',
        action_created: 'Создана',
        action_updated: 'Изменена',
        action_deleted: 'Удалена',
        field_name: 'Название',
        field_price: 'Цена',
        field_description: 'Описание',
        field_prefix: 'Префикс',
        field_time: 'Минуты',
        field_type: 'Тип',
        field_deleted_at: 'Удалена',
    },
};

export default ru;
